import axios from 'axios';
import CryptoJS from 'crypto-js';
import store from '@/store/index.js';

const BASE_URL = 'https://api.elkasy.de';

export default {
    /**
     * AUTH
     */
    sendAuth(email, password) {
        return axios.post(BASE_URL + '/login', {
            username: email,
            password: password
        }).then((response) => {
            store.commit('setUser', response.data);
            return response;
        });
    },
    /**
     * HELPER Methods
     */
    onError(error) {
        store.commit("logout");
        window.location.href = '/#/';

        let alerted = localStorage.getItem('alerted') || '';
        if (alerted !== 'yes') {
            alert("Ihre Login-Session ist leider abgelaufen. Bitte melden Sie sich erneut an.");

            localStorage.setItem('alerted', 'yes');
        }
    },
    get(url) {
        return axios.get(url, {
            headers: {
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    patch(url, data) {
        return axios.patch(url, data, {
            headers: {
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    getCached(url, storeVar, message) {
        if (storeVar === null) {
            return axios.get(url, {
                headers: {
                    "x-auth-header": store.state.auth
                }
            }).then((response) => {
                response.data.forEach((item) => {
                    if (item.order !== undefined) {
                        item.order = item.order + "-" + item.position;
                    }
                });

                store.commit(message, response);
                return response;
            }).catch((error) => {
                this.onError(error);
            });
        }

        return Promise.resolve(storeVar);
    },
    post(url, data) {
        return axios.post(url, data, {
            headers: {
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    postCached(url, data, message) {
        return axios.post(url, data, {
            headers: {
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            store.commit(message, response);
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    /**
     * GET Requests
     */
    getArticles() {
        let url = BASE_URL + '/article/' + store.state.user.org;
        console.log(url)

        return this.getCached(url, store.state.articles, 'setArticles');
    },
    getOpenPositions() {
        let url = BASE_URL + '/position/' + store.state.user.org + '/open';

        return this.getCached(url, store.state.openPositions, 'setOpenPositions');
    },
    getOpenOptimizationsCount() {
        let url = BASE_URL + '/optimizer/' + store.state.user.org + '/open';

        return this.get(url);
    },
    getReports() {
        let url = BASE_URL + '/reporting/' + store.state.user.org + '/automatic';

        return this.get(url);
    },
    getRoles() {
        let url = BASE_URL + '/role/' + store.state.user.org;

        return this.get(url);
    },
    getSystemStatus() {
        let url = BASE_URL + '/systemstatus/' + store.state.user.org;

        return this.get(url);
    },
    getRevenueYear() {
        let url = BASE_URL + '/revenue/' + store.state.user.org + '/year';

        return this.get(url);
    },
    getMoverNoMover() {
        let url = BASE_URL + '/article/' + store.state.user.org + '/movements';

        return this.get(url);
    },
    getPriceHistory(articleId) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleId + '/pricehistory';

        return this.get(url);
    },
    getSuppliers() {
        let url = BASE_URL + '/supplier/rating';

        return this.getCached(url, store.state.suppliers, 'setSuppliers');
    },
    getTenders() {
        let url = BASE_URL + '/tender/' + store.state.user.org;

        return this.getCached(url, store.state.tenders, 'setTenders');
    },
    getTenderById(tenderId) {
        let url = BASE_URL + '/tender/' + store.state.user.org + '/' + tenderId;

        return this.get(url);
    },
    getElProcSy() {
        let url = BASE_URL + '/elprocsy/' + store.state.user.org;

        return this.getCached(url, store.state.elprocsy, 'setElprocsy');
    },
    getElProcSyOrders() {
        let url = BASE_URL + "/elprocsy/" + store.state.user.org + "/order";

        return this.get(url);
    },
    getElProcSyOpenOrders() {
        let url = BASE_URL + "/elprocsy/" + store.state.user.org + "/order/open";

        return this.get(url);
    },
    postElProcSyOrders(items) {
        let url = BASE_URL + "/elprocsy/" + store.state.user.org + "/order/received";

        let data = {
            data: items
        };

        return this.post(url, data);
    },
    getElProcSyOrderDetails(orderId) {
        let url = BASE_URL + "/elprocsy/" + store.state.user.org + "/order/" + orderId;

        return this.get(url);
    },
    getArticleSummary(articleID) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleID + '/summary';

        return this.get(url);
    },
    getArticleVariations(articleID) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleID;

        return this.get(url);
    },
    getPositionsPerDay() {
        let url = BASE_URL + '/position/' + store.state.user.org + '/daily';

        return this.get(url);
    },
    postArticlesForImport(formData) {
        let url = BASE_URL + '/customer/articles/' + store.state.user.org;

        return axios.put(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    putArticlesForImport(formData) {
        let url = BASE_URL + '/customer/articles/' + store.state.user.org;

        return axios.put(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    getStorages(articleID) {
        let url = BASE_URL + '/storage/' + store.state.user.org + '/' + articleID;

        return this.get(url);
    },
    getPositionsForArticle(articleID) {
        let url = BASE_URL + '/position/' + store.state.user.org + '/' + articleID;

        return this.get(url);
    },
    postReport(email, reportId) {
        let url = BASE_URL + '/reporting/' + store.state.user.org + '/automatic';

        let data = {
            ownerType: 'C',
            email: email,
            recipientId: reportId
        };

        return this.post(url, data);
    },
    getSupplierRatings(supplierID) {
        let url = BASE_URL + '/supplier/' + supplierID + "/rating";

        return this.get(url);
    },
    getSupplierDetails(supplierID) {
        let url = BASE_URL + '/supplier/' + supplierID;

        return this.get(url);
    },
    getSupplierItems(supplierID) {
        let url = BASE_URL + '/supplier/' + supplierID + "/article";

        return this.get(url);
    },
    getOptimizations() {
        let url = BASE_URL + '/optimizer/' + store.state.user.org;

        return this.getCached(url, store.state.optimizations, 'setOptimizations');
    },
    getDelayedPositions() {
        let url = BASE_URL + '/position/' + store.state.user.org + "/delayed";

        return this.get(url);
    },
    /**
     * POST Requests
     */
    startOptimizationScan() {
        let url = BASE_URL + '/optimizer/scan/' + store.state.user.org;

        return this.post(url, {});
    },
    getPositions(startDate, endDate) {
        let url = BASE_URL + '/position/' + store.state.user.org;

        let data = {
            startDate: startDate,
            endDate: endDate
        };

        return this.postCached(url, data, 'setPositions');
    },
    postSelectedArticlesForTender() {
        let url = BASE_URL + '/tender/' + store.state.user.org;

        let data = {
            customeritem_id: store.state.selectedArticles
        };

        return this.post(url, data);
    },
    postOptimizerAction(id, action) {
        let url = BASE_URL + '/optimizer/action/' + id;

        let data = {
            action: action
        };

        return this.post(url, data);
    },
    postElProcSyShoppingCart() {
        let url = BASE_URL + '/elprocsy/' + store.state.user.org + '/order';

        let data = {
            data: store.state.elprocsyShoppingCart
        };

        return this.post(url, data);
    },
    patchArticleInfo(articleId, customerArticleNumber, customerArticleDescription) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleId + '/info';

        let data = {
            customerArticleDescription: customerArticleDescription,
            customerArticleNumber: customerArticleNumber
        }

        return this.patch(url, data);
    },
    patchArticleAmount(articleId, newAmount, itemaccord_id) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleId + '/amount';

        let data = {
            quantity: newAmount,
            itemaccordId: itemaccord_id
        }

        return this.patch(url, data);
    },
    patchArticlePrice(articleId, newPrice, supplier) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/' + articleId + '/price';

        let data = {
            baseprice: newPrice,
            supplier: supplier
        }

        return this.patch(url, data);
    },
    getUserInfo() {
        let url = BASE_URL + '/user/me';

        return this.get(url);
    },
    putUserInfo(userId, addressForm, firstName, lastName, title, phone, email) {
        let url = BASE_URL + '/user/edit/' + userId;

        let data = {
            mail: email,
            phone: phone,
            lastName: lastName,
            firstName: firstName,
            title: title,
            addressForm: addressForm
        };

        return axios.put(url, data, {
            headers: {
                "x-auth-header": store.state.auth
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            this.onError(error);
        });
    },
    postExportArticlesForImport(ids) {
        let url = BASE_URL + '/article/' + store.state.user.org + '/export';
        let data = {
            data: ids
        }
        return axios.post(url, data, {
            headers: {
                "x-auth-header": store.state.auth
            },
            responseType: 'blob'
        }).then((response) => {
            var contentType = response.headers['content-type']
            var blob = new Blob([response.data],{type:contentType});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var name = response.headers['content-disposition'].split('=')[1]
            link.download = name;
            link.click();
        }).catch((error) => {
            this.onError(error);
        });
    },
};
